import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Play, X } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const workCategories = [
  { id: 'all', name: 'ALL' },
  { id: 'brand-mini', name: 'BRAND MINI SERIES' },
  { id: 'brand-films', name: 'TVC' },
  { id: 'influencers', name: 'INFLUENCERS FILM' },
  { id: 'govt-csr', name: 'GOVT/CSR FILMS' }
];

const workItems = [
  // BRAND MINI SERIES
  {
    id: 1,
    category: 'brand-mini',
    thumbnail: 'https://img.youtube.com/vi/y5xaIWaW3H0/maxresdefault.jpg',
    videoId: 'y5xaIWaW3H0'
  },
  {
    id: 2,
    category: 'brand-mini',
    thumbnail: 'https://img.youtube.com/vi/YD4FOTe9FQY/maxresdefault.jpg',
    videoId: 'YD4FOTe9FQY'
  },
  {
    id: 3,
    category: 'brand-mini',
    thumbnail: 'https://img.youtube.com/vi/zkoxdHzjm_Q/maxresdefault.jpg',
    videoId: 'zkoxdHzjm_Q'
  },
  {
    id: 4,
    category: 'brand-mini',
    thumbnail: '/Brand Film 4.png',
    videoId: 'y5xaIWaW3H0'
  },
  
  // BRAND FILMS / TV COMMERCIALS
  {
    id: 5,
    category: 'brand-films',
    thumbnail: '/Brand Film 1.png',
    videoId: 'VuahSCrw2b4'
  },
  {
    id: 6,
    category: 'brand-films',
 thumbnail: '/Brand Film 2.png',
     videoId: 'f-1UDEuhzYw'
  },
  {
    id: 7,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/ViqWLmUcgeA/maxresdefault.jpg',
    videoId: 'ViqWLmUcgeA'
  },
  {
    id: 8,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/SF6wK-ZycT8/maxresdefault.jpg',
    videoId: 'SF6wK-ZycT8'
  },
  {
    id: 9,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/-HtiiN_THnc/maxresdefault.jpg',
    videoId: '-HtiiN_THnc'
  },
  {
    id: 10,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/3KNu6DMGh0s/maxresdefault.jpg',
    videoId: '3KNu6DMGh0s'
  },
  {
    id: 11,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/DvCO1WBMOKs/maxresdefault.jpg',
    videoId: 'DvCO1WBMOKs'
  },
  {
    id: 12,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/9NPzZe3iU9Y/maxresdefault.jpg',
    videoId: '9NPzZe3iU9Y'
  },
  {
    id: 13,
    category: 'brand-films',
    thumbnail: 'https://img.youtube.com/vi/PyIHaIfuOfs/maxresdefault.jpg',
    videoId: 'PyIHaIfuOfs'
  },
  
  // INFLUENCERS FILM - DIFFERENT LANGUAGE
  {
    id: 14,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/PrtyXo6zsBA/maxresdefault.jpg',
    videoId: 'PrtyXo6zsBA'
  },
  {
    id: 15,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/Qe7PjFWihKA/maxresdefault.jpg',
    videoId: 'Qe7PjFWihKA'
  },
  {
    id: 16,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/Szv04Bj-AG0/maxresdefault.jpg',
    videoId: 'Szv04Bj-AG0'
  },
  {
    id: 17,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/dUvrfdu_vq8/maxresdefault.jpg',
    videoId: 'dUvrfdu_vq8'
  },
  {
    id: 18,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/ZVWxQfGsnQU/maxresdefault.jpg',
    videoId: 'ZVWxQfGsnQU'
  },
  {
    id: 19,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/zDrhFxeL0rg/maxresdefault.jpg',
    videoId: 'zDrhFxeL0rg'
  },
  {
    id: 20,
    category: 'influencers',
    thumbnail: 'https://img.youtube.com/vi/jRKaayc-S98/maxresdefault.jpg',
    videoId: 'jRKaayc-S98'
  },
  
  // GOVT/CSR FILMS
  {
    id: 21,
    category: 'govt-csr',
    thumbnail: 'https://img.youtube.com/vi/ZOgyf-qsNoM/maxresdefault.jpg',
    videoId: 'ZOgyf-qsNoM'
  },
  {
    id: 22,
    category: 'govt-csr',
 thumbnail: '/CSR Film 2.png',
    videoId: 'drive-1hP3Gnje1qGI7T3LLf6AF1Go-7s6JnZgK',
    isDrive: true
  },
  {
    id: 23,
    category: 'govt-csr',
 thumbnail: '/CSR Film 3.png',
    videoId: 'drive-1bGF-fz2_ZSRKwxgBV9FZNn8SvG9Cg2cA',
    isDrive: true
  },
  {
    id: 24,
    category: 'govt-csr',
 thumbnail: '/CSR Film 4.png',
    videoId: 'drive-1D54cGrDl8TazJP1g5XdYm48aMaaIlBcf',
    isDrive: true
  },
  {
    id: 25,
    category: 'govt-csr',
 thumbnail: '/CSR Film 5.png',
    videoId: 'drive-1vOITwHpN-oF6fQMJWJLRTJkCFLc1dnfR',
    isDrive: true
  },
  {
    id: 26,
    category: 'govt-csr',
 thumbnail: '/CSR Film 6.png',
    videoId: 'drive-1N9cCIqSh0HVmI11lCbn39LAvc9WYLhfD',
    isDrive: true
  },
  {
    id: 27,
    category: 'govt-csr',
 thumbnail: '/CSR Film 7.png',
    videoId: 'drive-11RP7hg8ZZzMBhjkgBR3ZjV2P6RSIqUH3',
    isDrive: true
  },
  {
    id: 28,
    category: 'govt-csr',
 thumbnail: '/CSR Film 8.png',
    videoId: 'drive-1TiOk__z82FWT54Y8MwQ88RV71NtlSCBF',
    isDrive: true
  }
];

const WorkPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeVideo, setActiveVideo] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const filteredWork = activeCategory === 'all'
    ? workItems
    : workItems.filter(item => item.category === activeCategory);

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      <main className="pt-32 pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-[1800px] mx-auto">
          {/* Page Title */}
          <div
            className={`mb-16 transition-all duration-1000 ${
              isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
            }`}
          >
            <h1
              className="text-white text-5xl md:text-7xl lg:text-8xl tracking-wide font-spectral"
              style={{ fontFamily: "'Spectral SC', serif" }}
            >
              OUR WORK
            </h1>
          </div>

          {/* Category Filter */}
          <div
            className={`flex flex-wrap gap-4 md:gap-8 mb-16 transition-all duration-1000 delay-200 ${
              isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
            }`}
          >
            {workCategories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`text-xs tracking-[0.2em] pb-2 transition-all duration-300 ${
                  activeCategory === cat.id
                    ? 'text-white border-b border-white'
                    : 'text-white/50 hover:text-white'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          {/* Work Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredWork.map((item, index) => (
              <div
                key={item.id}
                className={`group cursor-pointer transition-all duration-700 ${
                  isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'
                }`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
                onClick={() => setActiveVideo(item)}
              >
                <div className="relative aspect-video overflow-hidden bg-zinc-900">
                  <img
                    src={item.thumbnail}
                    alt=""
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-500" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                    <div className="bg-white text-black px-6 py-3 rounded-full flex items-center gap-2 font-medium text-sm">
                      <Play size={16} className="ml-1" fill="black" />
                      WATCH NOW
                    </div>
                  </div>
                </div>
                <p className="text-white/50 text-xs tracking-[0.2em] mt-1 uppercase">
                  {item.category}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />

      {/* Video Modal */}
      {activeVideo && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95"
          onClick={() => setActiveVideo(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:opacity-60 transition-opacity"
            onClick={() => setActiveVideo(null)}
          >
            <X size={32} />
          </button>
          <div
            className="w-full max-w-5xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            {activeVideo.isDrive ? (
              <iframe
                src={`https://drive.google.com/file/d/${activeVideo.videoId.replace('drive-', '')}/preview`}
                title=""
                className="w-full h-full"
                allow="autoplay"
                allowFullScreen
              />
            ) : (
              <iframe
                src={`https://www.youtube.com/embed/${activeVideo.videoId}?autoplay=1`}
                title=""
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkPage;
